export const hreflangMappper: Record<string, { hreflang: string; domain: string }> = {
    de: { hreflang: 'de-DE', domain: 'https://go.wemolo.de' },
    at: { hreflang: 'de-AT', domain: 'https://go.wemolo.at' },
    ch: { hreflang: 'de-CH', domain: 'https://go.wemolo.ch' },
    fr: { hreflang: 'fr-FR', domain: 'https://go.wemolo.fr' },
    it: { hreflang: 'it-IT', domain: 'https://go.wemolo.it' },
    com: { hreflang: 'en', domain: 'https://go.wemolo.com' },
    pl: { hreflang: 'en-PL', domain: 'https://go.wemolo.pl' },
    dk: { hreflang: 'en-DK', domain: 'https://go.wemolo.dk' }
}
